<template>
  <div class="app-container">
    <div class="main-content">
      <div class="title">{{ courseDetail.name || '课程详情' }}</div>
      <div class="head">
        <span>当前位置：</span>
        <div class="breadcrumb">
          <span class="route" @click="gohome">首页</span>
          <span>> </span>
          <span class="route" @click="gocourse">课程</span>
          <span>> </span>
          <span>详情</span>
          <el-divider direction="vertical"></el-divider>
          <span>发布时间：{{ formatDate(courseDetail.createTime) }}</span>
          <el-divider direction="vertical"></el-divider>
          <span>类别：{{ courseDetail.typeName || '未知' }}</span>
        </div>
      </div>
      <div class="content">
        <div class="left">
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
            <el-menu-item index="1">课程概述</el-menu-item>
          </el-menu>
          <img
            style="width: 100%"
            :src="courseDetail.coverUrl || 'https://web-1322480718.cos.ap-nanjing.myqcloud.com/20240316/20240316102814_t19d.png?imageMogr2/format/webp'"
            alt="课程封面"
          />
          <div style="padding: 20px; background: #fff; margin-top: 20px; border-radius: 10px;" v-if="courseDetail.content">
            <h3>课程介绍</h3>
            <div v-html="courseDetail.content"></div>
          </div>
        </div>
        <div class="right">
          <div class="teacherbox">
            <div class="head">
              <img
                :src="teacherInfo.realHead || teacherInfo.avatar || 'https://web-1322480718.cos.ap-nanjing.myqcloud.com/20240807/20240807122351_esxl.jpg'"
                alt="讲师头像"
              />
              <div>
                <div class="name">讲师：{{ teacherInfo.nickName || teacherInfo.name || '待分配' }}</div>
                <div class="type">{{ teacherInfo.title || '金牌讲师' }}</div>
              </div>
            </div>
            <div class="course">{{ courseDetail.name || '课程名称' }}</div>
            <div class="nums">当前 {{ courseDetail.applicantsNumber || 0 }} 人 已报名</div>
            <div class="price">{{ courseDetail.fee ? '￥' + courseDetail.fee : '免费' }}</div>
            <div class="btn">
              <el-button type="primary">我要报名</el-button>
            </div>
          </div>
          <div>
            <div class="titlebox">
              <div class="linebox"></div>
              <div class="title">课程推荐</div>
            </div>
            <div class="card" v-for="(item, i) in recommendCourses" :key="i" @click="goToCourseDetail(item)">
              <img :src="item.coverUrl" alt="" />

              <div style="padding: 20px">
                <p>{{ item.name }}</p>

                <p style="color: red; margin-bottom: '15px'">{{ item.fee ? '￥' + item.fee : '免费' }}</p>

                <!-- <el-divider style="margin:10px"></el-divider> -->

                <div
                  style="
                    display: block;
                    width: 100%;
                    margin: 0 0 10px 0;
                    border: 1px solid #dde2ee;
                  "
                ></div>

                <div class="perinfo">
                  <img class="headimg" :src="item.teacherAvatars && item.teacherAvatars[0] ? item.teacherAvatars[0] : 'https://web-1322480718.cos.ap-nanjing.myqcloud.com/20240807/20240807122351_esxl.jpg'" alt="" />

                  <span>{{ item.teacherNames && item.teacherNames[0] ? item.teacherNames[0] : '讲师' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getcourse, courseinfo } from "@/api/index.js";

export default {
  name: "courseDetails",
  components: {},
  data() {
    return {
      id: this.$route.query.id, // 从query参数获取ID
      courseDetail: {}, // 课程详情
      teacherInfo: {}, // 讲师信息
      recommendCourses: [], // 推荐课程
      activeIndex: "1",
    };
  },
  created() {
    if (this.id) {
      this.getCourseDetail();
    } else {
      this.$message.error('课程ID参数缺失');
      this.gocourse();
    }
  },
  methods: {
    // 获取课程详情
    getCourseDetail() {
      getcourse({ id: this.id }).then((res) => {
        if (res.data) {
          this.courseDetail = res.data;
          
          // 直接从课程详情中获取教师信息
          if (this.courseDetail.teacherNames && this.courseDetail.teacherNames.length > 0) {
            // 构建教师信息对象
            this.teacherInfo = {
              nickName: this.courseDetail.teacherNames[0],
              name: this.courseDetail.teacherNames[0],
              realHead: this.courseDetail.teacherAvatars && this.courseDetail.teacherAvatars[0] ? this.courseDetail.teacherAvatars[0] : null,
              avatar: this.courseDetail.teacherAvatars && this.courseDetail.teacherAvatars[0] ? this.courseDetail.teacherAvatars[0] : null,
              title: '金牌讲师' // 默认职称
            };
            console.log('从课程详情中获取的教师信息:', this.teacherInfo);
          }
          
          // 获取课程详情后再获取推荐课程
          this.getRecommendCourses();
        } else {
          this.$message.error('获取课程详情失败');
        }
      }).catch(error => {
        console.error('获取课程详情失败:', error);
        this.$message.error('获取课程详情失败');
      });
    },
    
    // 获取推荐课程
    getRecommendCourses() {
      // 获取同类型的其他课程作为推荐
      // 将typeId映射为对应的type值
      let typeMap = {
        1: "1", // 编程学院
        2: "2", // 公开课
        3: "3", // 进阶课
        4: "4", // 专项课
        5: "5", // 综合课
      };
      
      let courseType = typeMap[this.courseDetail.typeId] || "1";
      
      courseinfo({
        pageNo: 1,
        pageSize: 3,
        typeId: courseType
      }).then((res) => {
        if (res.data && res.data.list) {
          // 过滤掉当前课程
          this.recommendCourses = res.data.list.filter(item => item.id != this.id);
          // 如果推荐课程不够，补充其他类型的课程
          if (this.recommendCourses.length < 2) {
            this.getMoreRecommendCourses();
          }
        }
      }).catch(error => {
        console.error('获取推荐课程失败:', error);
      });
    },
    
    // 获取更多推荐课程
    getMoreRecommendCourses() {
      courseinfo({
        pageNo: 1,
        pageSize: 5
      }).then((res) => {
        if (res.data && res.data.list) {
          // 过滤掉当前课程和已有推荐课程
          const existingIds = this.recommendCourses.map(item => item.id);
          const moreCourses = res.data.list.filter(item => 
            item.id != this.id && !existingIds.includes(item.id)
          );
          
          // 补充到2个推荐课程
          const needed = Math.max(0, 2 - this.recommendCourses.length);
          this.recommendCourses = this.recommendCourses.concat(moreCourses.slice(0, needed));
        }
      }).catch(error => {
        console.error('获取更多推荐课程失败:', error);
      });
    },
    
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '未知';
      const date = new Date(dateString);
      return date.toLocaleDateString('zh-CN');
    },
    
    // 跳转到课程详情
    goToCourseDetail(course) {
      this.$router.push({ path: "/coursedetals", query: { id: course.id } }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由跳转错误:', err);
        }
      });
    },
    
    gohome() {
      this.$store.commit("activeNavIndex", 0);
      this.$router.push({ path: "/home" }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由跳转错误:', err);
        }
      });
    },
    gocourse() {
      this.$store.commit("activeNavIndex", 1);
      this.$router.push({ path: "/course" }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由跳转错误:', err);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.app-container {
  padding: 0;
  margin: 0;
  font-family: "Microsoft YaHei";
  color: #333;
  overflow: hidden;
  background: #f5f6f9;
  clear: both;
  text-align: left;
  .main-content {
    width: 1200px;
    margin: 0 auto;
    overflow: visible;
    position: relative;
    .title {
      margin: 18px 0 0;
      font-size: 18px;
    }
    .head {
      width: 100%;
      display: flex;
      align-items: center;
      padding: 20px 0;
      .breadcrumb {
        font-size: 14px;
        span {
          margin-right: 5px;
          cursor: default;
        }
        .route {
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
    .content {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-bottom: 100px;
      .left {
        width: 760px;
        padding: 0 20px 20px 20px;
        background: #fff;
        border-radius: 10px;
      }
      .right {
        .teacherbox {
          width: 328px;
          background-color: #fff;
          padding: 26px;
          border-radius: 10px;
          background-color: #fff;
          border-radius: 10px;
          .head {
            width: 100%;
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            img {
              width: 72px;
              height: 72px;
              border-radius: 50%;
              margin-right: 16px;
            }
            .name {
              font-size: 18px;
              color: #2d3341;
              font-weight: 700;
              margin-bottom: 16px;
            }
            .type {
              font-size: 16px;
              color: #2d3341;
            }
          }
          .course {
            font-size: 20px;
            color: #2d3341;
            margin-bottom: 32px;
          }
          .nums {
            font-size: 16px;
            color: #2d3341;
            margin-bottom: 10px;
          }
          .price {
            font-size: 20px;
            color: #d5182f;
            margin-bottom: 60px;
          }
          .btn {
            display: flex;
            justify-content: center;
            width: 100%;
          }
        }
        .titlebox {
          display: flex;
          align-items: center;
          margin: 0 0 30px;
          .linebox {
            width: 7px;
            height: 36px;
            background: #f65f58;
            border-radius: 5px;
            margin-right: 20px;
          }

          .title {
            color: #2d3341;
            font-size: 30px;
          }
        }
        .card {
          clear: both;
          width: 360px;
          // height: 354px;
          background-color: #fff;
          border-radius: 10px;
          overflow: hidden;
          margin: 24px 0 40px 0;
          box-shadow: 0 0.125rem 0.3125rem rgba(0, 0, 0, 0.1);

          img {
            width: 360px;
            height: 185px;
          }

          p {
            font-size: 18px;
            //   width: 263px;
            margin: auto;
            text-align: left;
            margin-bottom: 20px;
          }

          .perinfo {
            display: flex;
            align-items: center;
            color: #838a9d;

            .headimg {
              width: 44px;
              height: 44px;
              border-radius: 50%;
              margin-right: 10px;
            }

            span {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 1200px) {
  .app-container .main-content {
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
  }
}
@media (max-width: 992px) {
  .app-container .main-content .content {
    flex-direction: column;
  }
  .app-container .main-content .content .left {
    width: 100%;
    margin-bottom: 16px;
  }
  .app-container .main-content .content .right .teacherbox,
  .app-container .main-content .content .right .card {
    width: 100%;
  }
  .app-container .main-content .content .right .card img {
    width: 100%;
    height: auto;
  }
}

@media (max-width: 600px) {
  .app-container .main-content {
    padding: 0 12px;
  }
  .app-container .main-content .title {
    font-size: 16px;
  }
  .app-container .main-content .head .breadcrumb {
    font-size: 12px;
  }
  .app-container .main-content .content {
    gap: 12px;
    margin-bottom: 40px;
  }
  .app-container .main-content .content .left {
    padding: 12px;
  }
  .app-container .main-content .content .right .teacherbox,
  .app-container .main-content .content .right .card {
    padding: 12px;
  }
  .app-container .main-content .content .right .card img {
    width: 100%;
    height: auto;
  }
  .app-container .main-content .content .right .titlebox .title {
    font-size: 22px;
  }
}
</style>
